module.exports = __webpack_public_path__ + "img/arrow-left.17c788e0.svg";